/**
 * @author xyguo
 * @description 在线课程管理页面,展示所有在线课程信息
 * @Date 2020/1/20
 */
import React from 'react';
import { connect } from 'dva';
import moment from 'moment';
import { templateConfig, reduxTemplateCofig } from './config'
import { WizVersionTable } from '@/containers/common';
import { framework_tool, component_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool;
let { WizBrowserExport, WizCard, WizTabs, WizSpin, WizModal } = component_tool;

const formateProgramSource = (programSource) => {
  let programSourceStr = '';
  let dict = [
    { code: 1, codeName: "别克销售" },
    { code: 2, codeName: "雪佛兰销售" },
    { code: 3, codeName: "凯迪拉克销售" },
    { code: 4, codeName: "售后技术" },
    { code: 5, codeName: "售后非技术" },
    { code: 6, codeName: "二手车" },
    { code: 7, codeName: "凯迪新能源" },
    { code: 8, codeName: "集团销售" },
    { code: 9, codeName: "校企合作" },
    { code: 10, codeName: "融入辅导_相达" },
    { code: 11, codeName: "融入辅导_申先" },
    { code: 12, codeName: "TAC技术支持" },
    { code: 13, codeName: "其它" },
    { code: 14, codeName: "车工坊" },
    { code: 15, codeName: "德科" },
    { code: 19, codeName: "别克新能源" }
  ];
  dict.forEach(e => {
    if (e.code === programSource) {
      programSourceStr = e.codeName
    }
  })
  return programSourceStr
}

const formateVersionCurrentApplyTime = (time) => {
  let timeStr = '';
  if (time) {
    timeStr = moment(time).format('YYYY-MM-DD')
  }
  return timeStr
}


class ProgramList extends WizContainer {

  componentName = 'ProgramList';

  constructor(props) {
    super(props);
    this.state = {
      versionVisible: false,
      locRecord: {}
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }



  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '课程id',
        field: 'id',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程名称',
        field: 'name',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程编码',
        field: 'scoId',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '时长(分)',
        field: 'duration',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程受众',
        field: 'scope',
        width: 50,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '状态',
        field: 'statusStr',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '开始时间',
        field: 'startDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '截止时间',
        field: 'endDate',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程分类',
        field: 'programCategoryNames',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '品牌',
        field: 'brandCh',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '功能块',
        field: 'moduleCh',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '课程来源',
        field: 'programSource',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '讲师',
        field: 'lecturesName',
        width: 25,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '创建人姓名',
        field: 'fullName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '创建人账号',
        field: 'userName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '创建时间',
        field: 'createTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '当前版本',
        field: 'versionCurrentVersionNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '当前版本申请时间',
        field: 'versionCurrentApplyTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '版本更新记录',
        field: 'versionUpdateMark',
        width: 40,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center', wrapText: true },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']

      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
        let authData = d['authData']
        let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              let entityName = org['positionBrandName'] ? org['positionBrandName'] : org['name']
              target += entityName + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] + '(' + org['fullName'] + '),'
            });
            target += '\n'
          }
        }
        _d['versionCurrentApplyTime'] = formateVersionCurrentApplyTime(d['versionCurrentApplyTime'])
        _d['programSource'] = formateProgramSource(d['programSource'])
        _d['scope'] = target
        _data.push(_d)
      });

      WizBrowserExport({
        title: '课程信息',
        sheetName: '课程信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '课程信息.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _saveAuth = (values, changeModal) => {
    this.setState({
      changeModal: changeModal
    })
    this.doAction({
      path: "whitelist/save",
      payload: {
        key: "whitelist@save",
        apiParams: values
      }
    })
  }

  // 监听属性和状态的变化
  propsAndStateOnChange = {
    authInfo: this._authInfoOver.bind(this),
    fixProgramLogInfo: this._fixProgramLogInfoOver.bind(this),
  };

  _fixProgramLogInfoOver(nextProps, nextState) {
    if (nextProps.fixProgramLogInfo.code == 1) {
      wizNotice.success('保存成功');
    } else {
      wizNotice.error('提交失败：' + nextProps.fixProgramLogInfo.msg);
    }
    return true;
  }

  _authInfoOver(nextProps, nextState) {
    const { authInfo } = nextProps;
    if (authInfo.success) {
      wizNotice.success('保存成功');
      nextState.changeModal(false, true, true)
      return true;
    }
    return false;
  }
  openVersion = (record) => {
    this.setState({ versionVisible: true, locRecord: record })
  }
  _render() {
    let { versionVisible, locRecord } = this.state
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig({ self: this }),
      apiDataFormat: {
        add: this._handleCMD,
        update: this._handleCMD,
        delete: this._handleCMD,
        enable: this._handleCMD,
        UpdateProgramStatus: (nextProps, nextState, key) => {
          let o = nextProps[key]
          if (o['success']) {
            wizNotice.success(o['msg']);
            let bizIds = o['data']
            if (bizIds) {
              if (bizIds > 0) {

                WizModal.confirm({
                  title: '注意', content: "消息通知内容有变更，是否重新发送消息通知", cancelText: "否", okText: "是",
                  onOk: () => {
                    this.doAction({
                      path: "notice/sendNotice",
                      payload: {
                        key: "sendNoticeKey",
                        apiParams: {
                          bizId: bizIds,
                          bizType: 0,
                          resend: true
                        },
                      },
                    })
                  },
                  onCancel: () => {
                    this.doActions([
                      {
                        path: "notice/sendNotice",
                        payload: {
                          key: "sendNoticeKey",
                          apiParams: {
                            bizId: bizIds,
                            bizType: 0,
                            resend: false
                          },
                        },
                      },
                    ]);
                  }
                });
              } else {

                this.doActions([
                  {
                    path: "notice/sendNotice",
                    payload: {
                      key: "sendNoticeKey",
                      apiParams: {
                        bizId: 0 - bizIds,
                        bizType: 0,
                        resend: false
                      },
                    },
                  },
                ]);
              }
            }
            return true;
          } else {
            wizNotice.error(o['msg']);
            return false;
          }
        },
        export: this._handleFile
      },
    })
    return <>
      <WizReduxTemplate {..._reduxTemplateCofig} />
      <WizModal title={'版本管理'} visible={versionVisible} footer={null} width={1000} onCancel={() => this.setState({ versionVisible: false })}>
        <WizVersionTable record={locRecord}></WizVersionTable>
      </WizModal>
    </>
  }
}

const mapStateToProps = (state, ownProps) => {
  let { whitelist,program } = state
  const fixProgramLogInfo = modelUtils.getModelEntity(program, "program@fixProgramLog");
  const authInfo = modelUtils.getModelEntity(whitelist, 'whitelist@save');
  const load = modelUtils.getLoadingState(state, 'whitelist')
  return {
    authInfo,
    fixProgramLogInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ProgramList);
